'use client';

import { useEffect, useState } from 'react';

import Image from 'next/image';
import { playerVersion } from '@/helpers/images-helper';

const CustomPlayerImageWithDefault = ({
    playerId,
    width,
    height,
    alt = 'Imagen',
    className = '',
    style = {},
    onClick,
    unoptimized = true,
    priority = false,
    objectFit = 'cover',
    ...props
}) => {
    const defaultImage = `${process.env.NEXT_PUBLIC_IMAGES}/jugadores/0.png`;
    const analiticaImage = `${process.env.NEXT_PUBLIC_IMAGES}/jugadores/${playerId}.png?width=${width * 1.5}&height=${height * 1.5}&version=${playerVersion}`;
    const fallbackImage = `${process.env.NEXT_PUBLIC_DEFAULT_IMAGES}/players/${playerId}.png`;

    const [imageSrc, setImageSrc] = useState(analiticaImage);
    const [errorCount, setErrorCount] = useState(0);
    const [shouldRender, setShouldRender] = useState(true);

    useEffect(() => {
        if (!playerId) {
            setImageSrc(defaultImage);
            return;
        }
        setImageSrc(analiticaImage);
        setErrorCount(0);
        setShouldRender(true);
    }, [playerId, width, height]);

    const handleError = () => {
        const newErrorCount = errorCount + 1;
        setErrorCount(newErrorCount);

        if (newErrorCount === 1) {
            setImageSrc(fallbackImage);
        } else if (newErrorCount === 2) {
            setImageSrc(defaultImage);
        } else if (newErrorCount >= 3) {
            setShouldRender(false);
            console.error(`❌ No se pudo cargar ninguna imagen para el jugador ${playerId}`);
        }
    };

    if (!shouldRender) {
        return null;
    }

    return (
        <Image
            src={imageSrc}
            width={width}
            height={height}
            alt={alt}
            className={className}
            style={{ ...style, objectFit }}
            onClick={onClick}
            unoptimized={unoptimized}
            priority={priority}
            onError={handleError}
            {...props}
        />
    );
};

export default CustomPlayerImageWithDefault;
